package com.bikompanion.data

import kotlinx.serialization.Serializable

@Serializable
data class CityBikesNetworkDto(
    val id: String,
    val name: String,
    val location: CityBikesLocationDto,
    // Explicitly null for some networks, not merely absent, so the type has to allow it.
    val company: List<String>? = null,
    val href: String? = null,
    val license: CityBikesLicenseDto? = null,
)
